import { clsx } from 'clsx'
import type { CSSProperties, PropsWithChildren } from 'react'
import { Slot } from '@radix-ui/react-slot'
import { badge, type FillLevel, type HighlightColor } from './Badge.css'

type HighlightVariant = `${HighlightColor}${FillLevel}`
type GreyVariant = `grey${FillLevel}`
type FrostedVariant = `frosted${FillLevel}`
type WhiteVariant = 'white'

export type BadgeVariant = HighlightVariant | GreyVariant | FrostedVariant | WhiteVariant | 'outline' | 'redElement'

export type BadgeProps = PropsWithChildren<{
  asChild?: boolean
  as?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p' | 'div'
  className?: string
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'responsive'
  style?: CSSProperties
  variant?: BadgeVariant
}>

export function Badge({
  asChild,
  as = 'div',
  className,
  size = 'medium',
  style,
  variant = 'blue1',
  children,
  ...props
}: BadgeProps) {
  const Component = asChild ? Slot : as

  return (
    <Component className={clsx(badge({ size, variant }), className)} style={style} {...props}>
      {children}
    </Component>
  )
}
